import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/api-url-helper';
import { HostFreezeLabelConstant } from 'src/app/constants/LabelConstants';
import { CommonService } from 'src/app/services/common/common.service';
import { FreezeSessionConflictsComponent } from '../freeze-session-conflicts/freeze-session-conflicts.component';
import { BookedSessionCustomerListForFreezeComponent } from '../booked-session-customer-list-for-freeze/booked-session-customer-list-for-freeze.component';

@Component({
    selector: 'app-confirm-freeze',
    templateUrl: './confirm-freeze.component.html',
    styleUrls: ['./confirm-freeze.component.scss'],
    standalone: false
})
export class ConfirmFreezeComponent {

  sessionFreezeForm: FormGroup;
  submitted: boolean = false;
  hostId: any;
  sessionStartDateTime: any;
  sessionEndDateTime: any;
  labelConstant: any;
  classSessionIds: any;
  hasParticipants: boolean;
  conflictsData: any;
  customerCount: number;

  constructor(
    private dialogRef: MatDialogRef<ConfirmFreezeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private api: ApiUrlHelper,
    private commonService: CommonService,
    private dialog: MatDialog
  ) {
    this.hostId = data.hostIds;
    this.sessionStartDateTime = data.sessionStartDateTime;
    this.sessionEndDateTime = data.sessionEndDateTime;
    this.classSessionIds = data.classSessionIds;
    this.hasParticipants = data.hasParticipants;
  }

  ngOnInit(): void {
    this.getCustomerCount();
    this.labelConstant = HostFreezeLabelConstant;
    this.sessionFreezeForm = this.fb.group({
      addOnSessionon: [false],
      dateExtend: [false],
      weeks: ['']
    });
  }

  getCustomerCount() {
    this.spinner.show();
    let api = this.api.apiUrl.Class.GetCustomerContForFreeze;
    var obj = {
      ClassSessionIds : this.classSessionIds,
      OffSet: this.commonService.getTimeZone()
    }
    this.commonService.doPost(api,obj).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.spinner.hide();
          this.customerCount = response.data;
        } else {
          this.toastr.error(response.message);
          this.spinner.hide();
        }
      },
      error: (err) => {
        this.spinner.hide();
        console.log(err);
      }
    });
  }

  submitSessionFreezeForm() {
    if (this.sessionFreezeForm.value.dateExtend && (this.sessionFreezeForm.value.weeks === '' || this.sessionFreezeForm.value.weeks === 0)) {
      this.toastr.error("Please enter number of day(s).");
      return;
    }
    this.spinner.show();
    this.submitted = true;
    let api = this.api.apiUrl.Class.FreezeHost;
    let obj = {
      HostIds: this.hostId,
      FreezeStartTime: this.sessionStartDateTime ? this.sessionStartDateTime : null,
      FreezeEndTime: this.sessionEndDateTime ? this.sessionEndDateTime : null,
      IsAddOnSession: this.sessionFreezeForm.value.addOnSessionon ? this.sessionFreezeForm.value.addOnSessionon : false,
      IsDateExtend: this.sessionFreezeForm.value.dateExtend ? this.sessionFreezeForm.value.dateExtend : false,
      NoOfWeeksToExtend: this.sessionFreezeForm.value.weeks ? this.sessionFreezeForm.value.weeks : 0,
      SessionIds: this.classSessionIds
    }
    this.commonService.doPost(api, obj).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.toastr.success(response.message);
          this.spinner.hide();
          this.dialog.closeAll();
        } else {
          this.conflictsData = response.data;
          const dialogRef = this.dialog.open(FreezeSessionConflictsComponent, {
            width: '900px',
            data: { conflictsData: this.conflictsData },
            disableClose: true,
            autoFocus: false
          });
          dialogRef.afterClosed().subscribe((result) => {
          });
          this.spinner.hide();
        }
      },
      error: (err) => {
        this.spinner.hide();
        console.log(err);
      }
    });
  }

  viewBookedSessionCustomers() {
    const dialogRef = this.dialog.open(BookedSessionCustomerListForFreezeComponent, {
      width: '1000px',
      data: { classSessionId: this.classSessionIds },
      disableClose: true,
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((result) => {
    });
  }
}
